// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import ModalWithOverlay from '../modal/ModalWithOverlay';
import isAnyModalVisibleActions from '../../../actions/isAnyModalVisibleActions';
import './EmailModal.scss';

type EmailModalProps = {
  submitHandler: * => void,
  emailInputHandler: * => void,
  email: string,
  isShowingEmailErrorMessage: boolean,
  isShowingEmailSuccessMessage: boolean,
  isSendEmailButtonDisabled: boolean,
  closeModalHandler: * => void,
  isModalOn: boolean,
  emailModalText: {
    emailIntro: string,
    emailPlaceholder: string,
    emailError: string,
    emailSent: string,
    sendEmail: string,
  },
  closeBox: string,
  modalHeadingRef: (c: ?HTMLHeadingElement) => void,
  modalWarningRef: (c: ?HTMLParagraphElement) => void,
};

const EmailModal = ({
  submitHandler,
  emailInputHandler,
  email,
  isSendEmailButtonDisabled,
  isShowingEmailErrorMessage,
  isShowingEmailSuccessMessage,
  closeModalHandler,
  isModalOn,
  closeBox,
  modalHeadingRef,
  modalWarningRef,
  emailModalText: {
    emailIntro,
    emailPlaceholder,
    emailError,
    emailSent,
    sendEmail,
  }
}: EmailModalProps): React.HTMLFormElement => {
  let emailInputClassName = '';
  if (isShowingEmailErrorMessage) emailInputClassName = 'error';
  else if (isShowingEmailSuccessMessage) emailInputClassName = 'success';

  return (
    <ModalWithOverlay
      clickHandler={closeModalHandler}
      isModalOn={isModalOn}
      id="email-modal"
      closeBox={closeBox}
    >
      <form onSubmit={submitHandler}>
        <div className="modal-content">
          <label id="email-modal-modal-title" htmlFor="email" ref={modalHeadingRef} tabIndex="-1">{emailIntro}</label>
          <input
            id="email"
            name="email"
            type="text"
            value={email}
            onChange={emailInputHandler}
            placeholder={emailPlaceholder}
            className={emailInputClassName}
          />
          <div className="message">
            {isShowingEmailErrorMessage && (
              <p className="error focus-start" ref={modalWarningRef} tabIndex="-1">{emailError}</p>
            )}
            {isShowingEmailSuccessMessage && (
              <p className="success focus-start" ref={modalWarningRef} tabIndex="-1">{emailSent}</p>
            )}
          </div>
          <div className="nav-buttons-container">
            <button
              type="submit"
              disabled={isSendEmailButtonDisabled}
              className={`nav-button ${isSendEmailButtonDisabled ? 'disabled' : ''}`}
            >
              {sendEmail}
            </button>
          </div>
        </div>
      </form>
    </ModalWithOverlay>
  );
};

const mapDispatchToProps = isAnyModalVisibleActions;

export default connect(null, mapDispatchToProps)(EmailModal);
